// iter415 — Dashboard page header extracted from DashboardPage.jsx.
// Responsible for the title row + LIVE indicator + action button cluster
// (WhatsApp · Edit Layout · Reset · Customize Widgets · Take Tour · Theme).
// All state lives in the parent — this component is a controlled view.
import { Button } from '@/components/ui/button';
import {
  MessageCircle, Lock, Unlock, Settings2, HelpCircle,
} from 'lucide-react';
import ThemePicker from '@/components/ThemePicker';

export function DashboardHeader({
  themeAccentClass = '',
  themeMutedClass = '',
  wsConnected = false,
  isEditMode = false,
  onToggleEdit,
  onReset,
  onOpenWhatsApp,
  onOpenWidgetSettings,
  onStartTour,
  tr,
}) {
  return (
    <div className="flex justify-between items-start flex-wrap gap-3" data-testid="dashboard-header">
      <div>
        <h1
          className={`text-2xl sm:text-3xl font-bold font-outfit mb-1 tracking-tight ${themeAccentClass}`}
          data-testid="dashboard-title"
        >
          {tr('dash_title')}
        </h1>
        <div className="flex items-center gap-2">
          <p className={themeMutedClass || 'text-muted-foreground'}>
            {tr('dash_subtitle')}
          </p>
          {wsConnected && (
            <span
              className="inline-flex items-center gap-1 text-[10px] text-success bg-success/10 px-2 py-0.5 rounded-full"
              data-testid="live-indicator"
            >
              <span className="w-1.5 h-1.5 bg-success rounded-full animate-pulse" />LIVE
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-2 items-center flex-wrap">
        <Button
          size="sm"
          variant="outline"
          className="rounded-xl"
          onClick={onOpenWhatsApp}
          data-testid="dashboard-whatsapp-btn"
        >
          <MessageCircle size={14} className="mr-1" />WhatsApp
        </Button>
        <Button
          size="sm"
          variant={isEditMode ? 'default' : 'outline'}
          className={`rounded-xl ${isEditMode ? 'bg-orange-500 hover:bg-orange-600 text-white' : ''}`}
          onClick={onToggleEdit}
          data-testid="edit-layout-btn"
        >
          {isEditMode
            ? <><Lock size={14} className="mr-1" />Lock Layout</>
            : <><Unlock size={14} className="mr-1" />Edit Layout</>}
        </Button>
        {isEditMode && (
          <Button size="sm" variant="outline" className="rounded-xl" onClick={onReset} data-testid="reset-layout-btn">
            Reset
          </Button>
        )}
        <Button
          size="sm"
          variant="outline"
          className="rounded-xl"
          onClick={onOpenWidgetSettings}
          data-testid="widget-settings-btn"
        >
          <Settings2 size={14} className="mr-1" />
          {isEditMode ? 'Widgets' : tr('customize_widgets')}
        </Button>
        <Button
          size="sm"
          variant="outline"
          className="rounded-xl text-orange-600 border-orange-200 hover:bg-orange-50"
          onClick={onStartTour}
          data-testid="start-tour-btn"
        >
          <HelpCircle size={14} className="mr-1" />{tr('take_tour') || 'Take Tour'}
        </Button>
        <ThemePicker />
      </div>
    </div>
  );
}

export default DashboardHeader;
